module.exports = __webpack_public_path__ + "img/展示3.b9a28b76.png";